import React, { Component } from "react";
import { Image, Form, Button, Modal } from "react-bootstrap";
import EditImage from "../../../../assets/edit-image.svg";
import { TableTemplate } from "../../../reusableComponent/tableListing/cmstemplate";
import {
  pmgInvestListHeaderOptions,
  pmgUpdatesListHeaders
} from "../CmsManagement.constant";
import { userGroup } from "../../../../utils/userDetails";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CreateUser from "../../../../assets/Mask group.svg";
import CreateForm from "../pmgUp/CreateForm";
import { connect } from "react-redux";
import {
  getLocalstorage,
  isValidArray,
  removeItemFromLocalStorage
} from "../../../../helper";
import { get, isNull } from "lodash";
import CheckMark from "../../../../assets/CheckMark.svg";
import "react-datepicker/dist/react-datepicker.css";
import {
  getPmgUpdateAction,
  getHeadingAction,
  headingAddAction,
  editHeadingAction,
  getUpdate,
  getHeading
} from "../../../../actions/pmgTeam.action";
import { LoaderPage } from "../../../../component/Loader";
import { headingUpdate } from "../../../../services/apiServices";
import { getHeadingg } from "../../../../services/apiServices";
import request from "../../../../services/requestService";

const Params = {
  active: true
};

class Update extends Component {
  constructor(props) {
    super(props);
    this.updateModalRef = React.createRef();
    this.state = {
      offset: 0,
      filteredArray: [],
      noFilterData: false,
      searchInputData: "",
      isEdit: false,
      paginationoffset: 0,
      showBubbleFilter: false,
      selectedFilter: null,
      makeSelectedNull: false,
      showTable: false,
      displayModal: false,
      isPmgActive: true,
      data: true,
      makeUserActiveInfo: null,
      pmgHeading: this.props.headingTitle,
      pmgHeadingId: 4,
      pmgData: [],
      usersListParams: { ...Params },
      groupData: {},
      isMakeUserApiLoading: false,
      isEditingHeading: false,
      currentPage: 1,
      recordsPerPage: 10,
      showLoader: true,
      checkboxLoader: false

      // pmgData: [
      //   {
      //     id: 1,
      //     name:
      //       "Project Monitoring Group (PMG) monitored over 1912 projects with investment of Rs 64 lakh crores; facilitated resolution of 5,438 issues",
      //     date: 16 / 12 / 2022,
      //     active: "Yes"
      //   },
      //   {
      //     id: 2,
      //     name:
      //       "In last two years about 696 issues pertaining to big ticket projects have been resolved through the mechanism of PRAGATI and Project Monitoring Group (PMG)",
      //     date: 15 / 12 / 2022,
      //     active: "Yes"
      //   },
      //   {
      //     id: 3,
      //     name:
      //       "Department for Promotion of Industry and Internal Trade (DPIIT) reviews 40 critical Infrastructure Projects across India",
      //     date: 26 / 8 / 2022,
      //     active: "Yes"
      //   },
      //   {
      //     id: 4,
      //     name:
      //       "Project Monitoring Group, DPIIT reviews 374 high impact infrastructure projects in FY 2021-22",
      //     date: 30 / 3 / 2022,
      //     active: "Yes"
      //   }
      // ]
    };
  }

  getInvestiListingData = async () => {
    let pmgInvestData = await getPmgUpdateAction(this.state.isPmgActive);
    let heading = await getHeadingAction();
    //console.log(heading);
    if (pmgInvestData) {
      this.setState({
        pmgData: pmgInvestData.data,
        showLoader: false
      });
    }
    if (heading) {
      //console.log("Ashish2", heading);
      this.setState({
        pmgHeading: heading.data.pmgUpdate.title,
        pmgHeadingId: heading.data.pmgUpdate.id,
        headerEditable: heading.data.isHeaderEditable
      });
    }
  };
  async componentDidMount() {
    this.getInvestiListingData();
    const response1 = await request(getHeadingg());
    this.setState({ pmgHeading: response1.data.data.pmgUpdate.title });
  }

  handleCheckbox = async () => {
    const { isPmgActive } = this.state;
    this.setState({
      isPmgActive: !isPmgActive,
      checkboxLoader: true
    });
    let data = await getPmgUpdateAction(!this.state.isPmgActive);
    if (data.status == true) {
      setTimeout(() => {
        this.setState({ checkboxLoader: false });
      }, 1000);
    }
    this.setState({
      pmgData: data.data
    });
  };

  userListApiCalling = e => {
    e.preventDefault();
    e.stopPropagation();
    const { getUsersListDispatch } = this.props;
    const { isPmgActive } = this.state;
    try {
      if (isPmgActive === true) {
        this.setState(
          prevState => ({
            usersListParams: {
              ...prevState.usersListParams,
              active: true
            }
          }),
          () => {
            getUsersListDispatch(undefined, this.state.usersListParams);
          }
        );
      } else {
        this.setState(
          prevState => ({
            usersListParams: {
              ...prevState.usersListParams,
              active: false
            }
          }),
          () => {
            getUsersListDispatch(undefined, this.state.usersListParams);
          }
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  handleClose = e => {
    this.setState({ isEdit: false });
  };

  handleReorder = (e, updatedPmgData) => {
    // e.preventDefault();
    // e.stopPropagation();
    this.setState({ pmgData: updatedPmgData });
  };

  onToggleModal = (e, value) => {
    this.setState(prevState => ({
      displayModal: !prevState.displayModal
    }));
  };

  onEdit = e => {
    //console.log("e", e);
    //console.log("e-options", value);
    //e.preventDefault();
    //e.stopPropagation();
    const editKey = getLocalstorage("editkey");
    //console.log("key", editKey);
    if (editKey && Object.values(editKey)[0] !== null) {
      this.setState(
        {
          groupData: e
        },
        () => {
          this.isIndexingRuningAtBackend(editKey);
        }
      );
    } else {
      removeItemFromLocalStorage("editkey");
      this.setState(prevState => ({
        isEdit: !prevState.isEdit,
        groupData: e
      }));
    }
  };
  onEditHeading = e => {
    this.setState({ isEditingHeading: true });
  };

  // onEdit = (e, value) => {
  //   console.log("valuee", e)
  //   //e.preventDefault();
  //   //e.stopPropagation();
  //   const editKey = getLocalstorage("editkey");
  //   console.log("editKey", editKey)
  //   if (editKey && Object.values(editKey)[0] !== null) {
  //     this.setState(
  //       {
  //         groupData: value
  //       },
  //       () => {
  //         this.isIndexingRuningAtBackend(editKey);
  //       }
  //     );
  //   } else {
  //     removeItemFromLocalStorage("editkey");
  //     this.setState(prevState => ({
  //       isEdit: !prevState.isEdit,
  //       groupData: value
  //     }));
  //   }
  // };

  onEditClick = async e => {
    this.setState({ isEditingHeading: false, showLoader: true });
    const payloadForEdit = {
      title: this.state.pmgHeading
    };
    const response = await request(
      headingUpdate(payloadForEdit, this.state.pmgHeadingId)
    );
    const response1 = await request(getHeadingg());
    this.props.onPMGUpdateChange(response1.data.data.pmgUpdate.title);
    this.setState({ showLoader: false });
  };

  handleEditHeading = e => {
    this.setState({ pmgHeading: e.target.value });
  };

  handleEditConfirmation = async e => {
    e.preventDefault();
    e.stopPropagation();
    const payloadForEdit = {
      name: this.props.groupData.name
        ? this.props.groupData.name
        : this.state.name
    };
    const responseData = await editHeadingAction(
      payloadForEdit,
      this.props.groupData.name
    );
    //console.log("from edit", responseData);
    return responseData;
  };

  handleAddMemberConfirmation = async e => {
    e.preventDefault();
    e.stopPropagation();
    const payloadForCreate = {
      name: this.state.name
    };
    const response = await headingAddAction(payloadForCreate);
    return response;
  };

  callApiOnSuccess = data => {
    this.setState({ showLoader: true });
    if (Object.keys(data).length > 0) {
      this.getInvestiListingData();
    }
  };

  handlePageChange = pageNumber => {
    this.setState({ currentPage: pageNumber });
  };

  render() {
    const { onMakeUserActive, onCloseModal } = this;
    const {
      pmgData,
      displayModal,
      isEdit,
      groupData,
      isEditGroup,
      isPmgActive,
      heading,
      data,
      isApiLoading,
      active,
      isMakeUserApiLoading,
      pmgHeading,
      currentPage,
      recordsPerPage,
      isEditingHeading
    } = this.state;
    const { permission } = this.props;
    //console.log(pmgHeading, "pmgHeading");
    //let isUserGroupCentralPMG = userGroup.centralPMG.PMG_SuperAdmin;
    let isUserGroupCentralPMG = this.state.headerEditable;
    const isSuperAdmin = get(permission, "superAdmin");

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords =
      pmgData && pmgData.slice(indexOfFirstRecord, indexOfLastRecord);

    // Calculate total number of pages
    const totalPages = pmgData && Math.ceil(pmgData.length / recordsPerPage);

    const renderPagination = () => {
      const pageNumbers = [];
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <li key={i} className={i === currentPage ? "active" : ""}>
            <div
              onClick={() => this.handlePageChange(i)}
              className={i === currentPage ? "active_page" : "disable_page"}
            >
              {i}
            </div>
          </li>
        );
      }
      return pageNumbers;
    };
    const dateFormate = inputDate => {
      //console.log("from dateFormate", inputDate);
      const timestamp = inputDate;
      const date = new Date(timestamp);

      const day = date.getDate();

      const month = date.getMonth() + 1; // Months are 0-indexed in JavaScript

      const year = date.getFullYear();
      //console.log("year", year);

      const paddedDay = day < 10 ? `0${day}` : day;
      const paddedMonth = month < 10 ? `0${month}` : month;

      return `${paddedDay}/${paddedMonth}/${year}`;
    };

    return (
      <>
        <LoaderPage loading={this.state.showLoader} />
        <div className="pmg-management pmg-listing">
          <div className="header">
            <div className="d-flex flex-row">
              {this.props.headingDetailsData.isHeaderEditable ? (
                <>
                  {isEditingHeading && (
                    <div className="d-flex gap-2">
                      <Form.Control
                        name="name"
                        type="text"
                        value={
                          this.state.pmgHeading !== null
                            ? this.state.pmgHeading
                            : ""
                        }
                        maxLength="30"
                        onChange={e => this.handleEditHeading(e)}
                        className="field-width"
                        style={{
                          width: "256px",
                          height: "50px",
                          fontFamily: "Metropolis"
                        }}
                      />
                      <Image
                        className="edit-image"
                        src={CheckMark}
                        onClick={e => {
                          this.onEditClick(e);
                        }}
                      />
                    </div>
                  )}

                  {this.props.headingDetailsData.isHeaderEditable &&
                    !isEditingHeading && (
                      <div className="d-flex gap-2">
                        <h3 className="mt-2">{pmgHeading}</h3>
                        <Image
                          className="edit-image"
                          src={EditImage}
                          onClick={e => {
                            this.onEditHeading(e);
                          }}
                        />
                      </div>
                    )}
                </>
              ) : (
                //  <h3 className="mt-2">{pmgHeading}</h3>
                <>
                  <h3 className="mt-2">{pmgHeading}</h3>
                  {/*{this.props.pemcilIcondisplay?<>*/}
                  {/*  <div className="d-flex gap-2">*/}
                  {/*    <Image*/}
                  {/*        className="edit-image"*/}
                  {/*        src={EditImage}*/}
                  {/*        onClick={e => {*/}
                  {/*          this.onEditHeading(e);*/}
                  {/*        }}*/}
                  {/*    />*/}
                  {/*  </div>*/}
                  {/*</>:null}*/}
                </>
              )}

              <Form.Check
                className={`form-checkbox pl-4 ${
                  isPmgActive === true ? "checked" : ""
                }`}
                disabled={!get(permission, "canViewOnlyProject")}
              >
                <Form.Check.Input type="checkbox" />
                <Form.Check.Label
                  className="d-flex active-check-mark"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleCheckbox(e);
                  }}
                >
                  <div className="active-check-label">ACTIVE UPDATES</div>
                </Form.Check.Label>
              </Form.Check>
            </div>
            <div className="header-buttons d-flex flex-row">
              <OverlayTrigger
                trigger="hover"
                defaultShow={false}
                placement="bottom"
                overlay={
                  <Tooltip
                    id={`tooltip-checking`}
                    className="create_project_tolltip"
                  >
                    Add New Update
                  </Tooltip>
                }
              >
                <Button
                  className={`btn-orange create-btn 
                }`}
                  size="sm"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.onToggleModal(e);
                  }}
                >
                  <div>
                    <Image src={CreateUser} className="create-user" />
                  </div>
                </Button>
              </OverlayTrigger>
            </div>
          </div>
          {/* {console.log("pmgData408", pmgData)} */}
          {/* <CmsTemplate
          bodyOptions={pmgData}
          isPmgTable={true}
          onReorder={e => {
            this.handleReorder(e);
          }}
          headersOptions={pmgUpdatesListHeaders}
        /> */}
          <TableTemplate
            isUsersTable={true}
            isBestPracticesTable={true}
            isEdit={true}
            headersOptions={pmgUpdatesListHeaders}
            //isLoading={isBestPracticesLoading === STATUS.LOADING}
            bodyOptions={pmgData}
            checkboxLoader={this.state.checkboxLoader}
            bodyTemplate={(options, index) => (
              <>
                <td>{index + 1}</td>
                <td className="pl-2">
                  <OverlayTrigger
                    placement="bottom-start"
                    key="bottom"
                    overlay={
                      <Tooltip
                        id="tooltip-bottom"
                        className="mis-tooltip"
                        placement="bottom-start"
                      >
                        {options.title}
                      </Tooltip>
                    }
                  >
                    {/* <div >
                             {data.projectTitle.length >= 50 ? <div style={{style}}>{data.projectTitle.substring(0, 50)}</div> : <div style={{style}}>{data.projectTitle} #{data.projectId}</div>}
                           </div> */}
                    <div
                    // style={{
                    //   display: "-webkit-box",
                    //   WebkitLineClamp: 2,
                    //   WebkitBoxOrient: "vertical",
                    //   overflow: "hidden",
                    //   whiteSpace: "pre-line"
                    // }}
                    >
                      {options.title}
                    </div>
                  </OverlayTrigger>
                </td>
                <td>{dateFormate(options.releaseDate)}</td>
                <td>{options.active ? "Yes" : "No"}</td>

                <td>
                  <Image
                    className={"edit-image"}
                    src={EditImage}
                    onClick={this.onEdit.bind(this, options)}
                  />
                  {/* <Image
                  className={"edit-image"}
                  src={DeleteImage}
                  onClick={this.onDelete.bind(this, options)}
                /> */}
                </td>
              </>
            )}
            headersTemplate={bestPracticesHeader => (
              <>
                <th>{bestPracticesHeader.title}</th>
              </>
            )}
          />

          <div>
            {/* Pagination */}
            {/* <ul className="pagination">
            <li>
              <button
                onClick={() =>
                  this.handlePageChange(currentPage > 1 ? currentPage - 1 : 1)
                }
                disabled={currentPage === 1}
                className="arrow_btn"
              >
                &#8249;
              </button>
            </li>
            {renderPagination()}
            <li>
              <button
                onClick={() =>
                  this.handlePageChange(
                    currentPage < totalPages ? currentPage + 1 : totalPages
                  )
                }
                className="arrow_btn"
                disabled={currentPage === totalPages}
              >
                &#8250;
              </button>
            </li>
          </ul> */}
          </div>

          {/*  Create Modal **/}
          <Modal
            size="lg"
            show={displayModal}
            onHide={e => {
              this.onToggleModal(e);
            }}
            aria-labelledby="example-modal-sizes-title-lg"
            className="content-modal  create-user-form"
          >
            <div className="modal-box-shadow" ref={this.updateModalRef}>
              <Modal.Header closeButton className="header-modal">
                <Modal.Title id="example-modal-sizes-title-lg">
                  Add Update
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="body-modal-cms  create-user-body-modal">
                <CreateForm
                  togglePopUp={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.onToggleModal(e);
                  }}
                  callApiOnSuccess={e => {
                    this.callApiOnSuccess(e);
                  }}
                  updateModalRef={this.updateModalRef}
                />
              </Modal.Body>
            </div>
          </Modal>
          {/*  Create Modal End **/}

          {/*<Modal*/}
          {/*  size="lg"*/}
          {/*  show={isEdit}*/}
          {/*  onHide={e => {*/}
          {/*    this.handleClose(e);*/}
          {/*  }}*/}
          {/*  aria-labelledby="example-modal-sizes-title-lg"*/}
          {/*  className="edit-user-modal-form"*/}
          {/*>*/}
          {/*  <div className="modal-box-shadow">*/}
          {/*    <Modal.Header closeButton className="header-modal">*/}
          {/*      <Modal.Title id="example-modal-sizes-title-lg">*/}
          {/*        {!get(permission, "canViewOnlyProject")*/}
          {/*          ? "Edit Update"*/}
          {/*          : "View Members"}*/}
          {/*      </Modal.Title>*/}
          {/*    </Modal.Header>*/}
          {/*    <Modal.Body className="body-modal-cms create-group">*/}
          {/*      /!* <CreateForm*/}
          {/*      togglePopUp={this.onEdit}*/}
          {/*      isEdit={isEdit}*/}
          {/*      updateData={updateData}*/}
          {/*      isEditGroup={isEditGroup}*/}
          {/*      callApiOnSuccess={this.callApiOnSuccess}*/}
          {/*    /> *!/*/}
          {/*      <CreateForm*/}
          {/*        togglePopUp={e => {*/}
          {/*          e.preventDefault();*/}
          {/*          e.stopPropagation();*/}
          {/*          this.onEdit(e);*/}
          {/*        }}*/}
          {/*        isEdit={isEdit}*/}
          {/*        groupData={groupData}*/}
          {/*        isEditGroup={isEditGroup}*/}
          {/*        callApiOnSuccess={e => {*/}
          {/*          this.callApiOnSuccess(e);*/}
          {/*        }}*/}
          {/*        edit*/}
          {/*        active={active}*/}
          {/*        permission={permission}*/}
          {/*        isMakeUserApiLoading={isMakeUserApiLoading}*/}
          {/*        isApiLoading={isApiLoading}*/}
          {/*      />*/}
          {/*    </Modal.Body>*/}
          {/*  </div>*/}
          {/*</Modal>*/}
          <Modal
            size="lg"
            show={isEdit}
            onHide={e => {
              this.handleClose(e);
            }}
            aria-labelledby="example-modal-sizes-title-lg"
            className="edit-user-modal-form"
          >
            <div className="modal-box-shadow" ref={this.updateModalRef}>
              <Modal.Header closeButton className="header-modal">
                <Modal.Title id="example-modal-sizes-title-lg">
                  {!get(permission, "canViewOnlyProject")
                    ? "Edit Update"
                    : "View Members"}
                </Modal.Title>
              </Modal.Header>
              {/* {console.log("fromupdate", this.state.groupData)} */}
              <Modal.Body className="body-modal-cms create-group">
                <CreateForm
                  togglePopUp={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.onEdit(e, pmgData);
                  }}
                  isEdit={isEdit}
                  groupData={groupData}
                  isEditGroup={isEditGroup}
                  callApiOnSuccess={this.callApiOnSuccess}
                  edit
                  active={active}
                  permission={permission}
                  isMakeUserApiLoading={isMakeUserApiLoading}
                  isApiLoading={isApiLoading}
                  updateModalRef={this.updateModalRef}
                />
              </Modal.Body>
            </div>
          </Modal>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    headingDetailsData: state.pmgReducer.headingDetailsData,
    usersListing: state.userManagementReducer.usersListing
  };
}

export default connect(
  mapStateToProps,
  {
    editHeadingAction
  }
)(Update);
